/**
 * 编译打印模板
 */
import {
  compileData,
  http,
  getDomain,
  numberAdd,
  convertCurrency,
  getValueByPath,
} from '../../../utils/index'
import Vue from 'vue'

//拆单逻辑
async function splitBill(compileSource, dataset) {
  if (dataset?.splitBill) {
    let urlParam = dataset?.splitBill
    let url = null
    let method = 'get'
    let params = {}
    if (typeof urlParam === 'object') {
      url = urlParam.url ?? url
      method = urlParam.method ?? 'get'
      params = compileData(urlParam.params ?? params, compileSource) //编译传入参数，参数支持{{}}
    } else {
      url = urlParam
    }
    url = compileData(url, compileSource)
    const [res] = await http[method](url, params)
    if (!res) {
      return []
    }
    const resArr = Array.isArray(res.data) ? res.data : [res.data]
    return resArr.map((im) => ({ ...compileSource, splitBillData: im }))
  } else {
    return [compileSource]
  }
}

//解析打印模板
function compileTemplate(content, data, style) {
  const escapeHtml = (string) => {
    var entityMap = {
      '&amp;': '&',
    }
    return String(string).replace(/&amp;/g, function (s) {
      return entityMap[s]
    })
  }
  let complieComponent = Vue.extend({
    data() {
      return data
    },
    methods: {
      getDomain(url) {
        return getDomain(url)
      },
      totalFn(arr, key, digits = 2, symbol, chinese) {
        let tempArr = arr || []
        let total = 0
        for (let item of tempArr) {
          total = numberAdd(total, getValueByPath(item, key), digits)
        }
        //表示需要将小写转为大写
        let date = new Date().format(total, 'number', digits)
        if (chinese) {
          // 数字为0时，重置date为空（如果不这样操作的话，数字为0时转大写，会原模原样返回，即：0或0.00 => 返回 0或0.00，就不能实现转大写的需求）
          var dataFixed = parseFloat(date.replace(/,/g, ''))
          if (!dataFixed) date = ''

          date = convertCurrency(date)
        }
        return `${symbol}${date}`
      },
      digitFn(date, digits = 2) {
        return new Date().format(date, 'number', digits)
      },
      getNowDate(formatter = 'YYYY-MM-DD HH:mm:ss', dateString = '') {
        let dateModel = new Date()
        if (dateString) dateModel = new Date(dateString)
        return dateModel.format(dateModel, 'date', formatter)
      },
      translateCode(data) {
        return window.encodeURI(data.replace(/\(/g, '[').replace(/\)/g, ']'))
      },
    },
    template: `<div>${content}</div>`,
  })
  //   如果没有style 就返回有style的字符串
  var complieComponentDom = new complieComponent().$mount()
  if (style) return escapeHtml(style + complieComponentDom.$el.innerHTML)
  else return escapeHtml(complieComponentDom.$el.innerHTML)
}

//编译打印模板
// str -> 打印的模板
// dataset -> 编译模板的数据源请求接口
// 需要排除 'splitBill' 'printBefore' 'staticData' 三个个key
// splitBill 用于拆单配置
// printBefore 用于打印前置函数调用判断的参数
// staticData 用于打印时额外参数，如lodop是否显示分页
//{
// order: 'rest/order/get?id={{order}}'
// orderItem: 'rest/order/getItem?id={{order}}'
//}
//这里是先将模板编译的数据通过接口获取到放入编译的源对象中，然后再进行模板编译；对应接口的key就是该接口返回的数据在编译对象中的key
async function compileContent({ content, dataset, data, style, html }) {
  const keys = Object.keys(dataset)
  const promiseArr = keys.reduce((pre, key) => {
    if (key !== 'splitBill' && key !== 'staticData' && key !== 'printBefore') {
      let urlParam = dataset[key]
      let url = null
      let method = 'get'
      let params = {}
      if (typeof urlParam === 'object') {
        url = urlParam.url ?? url
        method = urlParam.method ?? 'get'
        params = compileData(urlParam.params ?? params, data) //编译传入参数，参数支持{{}}
      } else {
        url = urlParam
      }
      url = compileData(url, data)
      pre.push(http[method](url, params).then(([res]) => ({ data: res?.data, key })))
    }
    return pre
  }, [])

  const resDatas = await Promise.all(promiseArr)
  const sourceData = resDatas.reduce(
    (pre, cur) => {
      // #38210, 浏览器版本过低会报错 Object.hasOwn(cur.data, 'items')
      if (cur.data && cur.data.hasOwnProperty('items') && !cur.data?.items?.length) {
        pre['_itemsLength'] = 0
      }
      pre[cur.key] = cur.data
      return pre
    },
    { ...data }
  )
  if (sourceData._itemsLength === 0) {
    return
  }

  return html ? compileTemplate(content, sourceData, style) : compileData(content, sourceData)
}

export async function printTemplateCompile({ compileDatas, printTemplate, html }) {
  const printTemplateContents = await compileDatas.reduce(async (pre, cur) => {
    const preValue = await pre
    const splitBillArr = await splitBill(cur.compileSource, printTemplate.dataset)
    for (const splitBillData of splitBillArr) {
      const content = await compileContent({
        content: printTemplate.content,
        dataset: printTemplate.dataset,
        data: splitBillData,
        style: printTemplate.style ?? '',
        html,
      })
      content &&
        preValue.push({
          content,
          _print_: splitBillData._print_ === 'undefined' ? 1 : splitBillData._print_,
        })
    }
    return preValue
  }, [])

  return {
    printTemplateContents,
  }
}
